import React from "react";
import ReactDom from "react-dom";

import FundingInteractiveApp from "./FundingInteractiveApp.jsx";

export default function renderFundingInteractive() {
  document
    .querySelectorAll(".js-funding-interactive-data-viz")
    .forEach((mount) => {
      const dataModel = JSON.parse(mount.dataset.model);
      const dataDictionary = JSON.parse(mount.dataset.dictionary);

      ReactDom.render(
        <FundingInteractiveApp {...dataModel} dictionary={dataDictionary} />,
        mount,
      );
    });
}
